<div [class.required]="required()">
    <app-label [label]="label()" customCss="text-sm text-gray-800" [required]="required()? '*': ''" />
    <input [(ngModel)]="value" spellcheck="false"
        class="w-full px-4 py-2 text-sm border border-gray-300 outline-none validation-indicator rounded-xl hover:focus-within:border-primary hover:border-primary-300 focus-within:border-primary"
        type="text" [placeholder]="placeholder() ?? ''" [autocomplete]="autocomplete()" />
    @if (errorMessage(); as error) {
    <p class="text-sm text-red-500 ">{{ error }}</p>
    }
</div>